import { initializeApp } from "firebase/app";
import { getAuth,RecaptchaVerifier,signInWithPhoneNumber, GoogleAuthProvider, OAuthProvider,FacebookAuthProvider } from 'firebase/auth';


// Your Firebase configuration
const firebaseConfig = {
 
  apiKey: "AIzaSyDzlogAFX7w_1wvqV5SGcDVSG851qahCfM",
 
  authDomain: "pushnotification-c511b.firebaseapp.com",
 
  projectId: "pushnotification-c511b",
 
  storageBucket: "pushnotification-c511b.firebasestorage.app",
 
  messagingSenderId: "139412557756",
 
  appId: "1:139412557756:web:f88a6a75d245d97362e5b9"
 
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

//google authentication
const provider = new GoogleAuthProvider();

//microsoft authentication
const microsoftProvider = new OAuthProvider('microsoft.com');
microsoftProvider.setCustomParameters({
  tenant: '6adf5668-0001-467d-9ede-0d07657d9570',
});
microsoftProvider.addScope('offline_access');

//apple authentication
const appleConfig = {
  clientId: 'YOUR_CLIENT_ID',
  clientSecret: 'YOUR_CLIENT_SECRET',
  redirectUri: 'YOUR_REDIRECT_URI',
};
const appleProvider = new OAuthProvider('apple.com');
appleProvider.setCustomParameters({
  client_id: appleConfig.clientId,
  client_secret: appleConfig.clientSecret,
  redirect_uri: appleConfig.redirectUri,
});
appleProvider.addScope('email');
appleProvider.addScope('name');


//facebook authentication
const facebookProvider = new FacebookAuthProvider();
facebookProvider.addScope('email');
facebookProvider.addScope('public_profile');
facebookProvider.setCustomParameters({
  'display': 'popup'
});

export { auth,RecaptchaVerifier,signInWithPhoneNumber, provider, microsoftProvider, appleProvider,facebookProvider };
 